const DEFAULTS = {
    firmBranches: {
        id: "branch_id",
        name: "branch_name"
    },
    department: {
        id: "department_id",
        name: "department_name"
    },
    expertise: {
        id: "expertise_id",
        name: "expertise_name"
    },
    industry: {
        id: "industry_id",
        name: "industry_name"
    },
    pageDetails: {
        id: "Bid",
        name: "Bucketname"
    },
    nicheGroups: {
        id: "nicheORgroup_id",
        name: "nicheORgroup_name"
    },
    rolesDetails: {
        id: "role_id",
        name: "role_name"
    },
    titleLevelList: {
        id: "titleORlevel_id",
        name: "titleORlevel_name"
    },
    rightsGroupNames: {
        id: "Group_id",
        name: "Group_name"
    },
    generationList: {
        id: "Generation_Type",
        name: "Generation_Type"
    },
    defaultCategory: {
        id: "defaultCategory_id",
        name: "defaultCategory_name"
    },
    timeZones: {
        id: "id",
        name: "name"
    },
    clientTypes: {
        id: "id",
        name: "clientTypeName"
    },
    suffix: {
        id: "generationTypeId",
        name: "generationTypeName"
    },
    locations: {
        id: "branchID",
        name: "branchName"
    },
    taskTypes: {
        id: "id",
        name: "name",
        code: "code"
    },
    clientGroups: {
        id: "groupId",
        name: "groupName",
        groupNumber: "groupNumber"
    },    
    clientStatus: {
        id: "id",
        name: "name"
    },
    roles:
    {
        id: "roleId",
        name: "roleName"
    },
    staffs:
    {
        id: "userId",
        name: "userName"
    }
};

export default DEFAULTS;
